/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoBackofficeRowDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    stato?: CittadinoBackofficeRowDTOStatoEnum;
    anonimizzato_il?: string;
}
export enum CittadinoBackofficeRowDTOStatoEnum {
    NESSUNA_EMAIL = 'NESSUNA_EMAIL',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_ATTIVAZIONE = 'IN_ATTESA_ATTIVAZIONE',
    DISABILITATO = 'DISABILITATO',
    ATTIVO = 'ATTIVO'
};



